import * as React from "react";
import "./EventTypeCard.scss";
import "@alaskaairux/auro-icon";
import dayjs from "dayjs";
import "../../theme/styles.css";
import { EventTypeReceived } from "../../Models/EventTypeReceived";

interface EventTypeProps {
  eventType: EventTypeReceived;
  onCardClick?: (eventType: EventTypeReceived) => void;
}



const getLocalDateTimeFromUTC = (dateTimeUTC: string): any => {
  const convertedTime = dayjs.utc(dateTimeUTC).local();
  return `${convertedTime.format("MM/DD/YY")}`;
};

const EventTypeCard: React.FC<EventTypeProps> = ({
  eventType,
  onCardClick,
}) => {
  const handleCardClick = () => {
    if (onCardClick) {
      onCardClick(eventType);
    }
  };

  return (
    <div>
      <div className="tileEventType" onClick={handleCardClick} role="button" tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleCardClick();
        }}}>
          <div className="name">
              <div className="eventTypeHeader">Event type name</div>
              <div className="eventTypeCardLabel">
                {eventType?.Name}
              </div>
            </div>
            <div className="category">
              <div className="eventTypeHeader">Legacy category</div>
              <div className="secondary-data-field">
                {eventType?.Category}
              </div>
            </div>
            <div className="createdBy">
              <div className="eventTypeHeader">Created by</div>
              <div className="secondary-data-field">{eventType?.CreatedBy}</div>
            </div>
            <div className="horizontalDivider" />
          <div className="reason">
             
              <div className="reasonField">{eventType?.Reason}</div>
          </div>
      </div>
    </div>
  );
};
export default EventTypeCard;
